// A lot is just work: measuring until the takeoff is done, exported once its
// order is written to the ERP. Bid status lives on the community (see
// COMMUNITY_STATUS_* below) — never on a project.
export type ProjectStatus = "measuring" | "exported"

export const PROJECT_STATUSES: ProjectStatus[] = ["measuring", "exported"]

export const STATUS_LABELS: Record<ProjectStatus, string> = {
  measuring: "Measuring",
  exported: "Exported",
}

export const STATUS_TONES: Record<ProjectStatus, "neutral" | "accent" | "signal" | "muted"> = {
  measuring: "neutral",
  exported: "accent",
}

// The bid, at the level that holds it.
export type CommunityStatus = "bidding" | "bid_sent" | "won" | "lost"

export const COMMUNITY_STATUSES: CommunityStatus[] = ["bidding", "bid_sent", "won", "lost"]

export const COMMUNITY_STATUS_LABELS: Record<CommunityStatus, string> = {
  bidding: "Bidding",
  bid_sent: "Bid sent",
  won: "Bid won",
  lost: "Lost",
}

export const COMMUNITY_STATUS_TONES: Record<
  CommunityStatus,
  "neutral" | "accent" | "signal" | "muted"
> = {
  bidding: "neutral",
  bid_sent: "signal",
  won: "accent",
  lost: "muted",
}

// What a community calls its parts (Community/Plan/Lot vs Building/Unit
// type/Unit). Serialized from Community#vocabulary — never derived client-side.
export type CommunityVocabulary = {
  container: string
  model: string
  unit: string
  units: string
}

/** Lowercased number agreement for vocabulary pairs: unitWord(vocab, 3) → "lots". */
export function unitWord(vocab: CommunityVocabulary, n: number): string {
  return (n === 1 ? vocab.unit : vocab.units).toLowerCase()
}
